import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Options } from './duplikit-options-config';

@Injectable()
export class DuplikitOptionsService {
  masterIdentificationHasChanged = {
    candidate: null,
    clientContact: null,
    clientCorporation: null
  };
  // TODO: code smell, duplicated.
  entityRefresh = {
    candidate: false,
    clientContact: false,
    clientCorporation: false
  };

  constructor(private http: HttpClient) {
  }

  getOptions(): Observable<Options> {
    return this.http.get<Options>(`${environment.duplikitUrl}/settings/getOptions`);
  }

  setOptions(options: Options): Observable<Options> {
    return this.http.post<Options>(`${environment.duplikitUrl}/settings/setOptions`, {options: options});
  }
}
